import { IRegion } from "../types";

export const makeSortFavoriteRegionFront = (favorite: string) => {
  return (region: IRegion): -1 | 0 => {
    return region.name === favorite ? -1 : 0;
  };
};
